import { useIntl } from 'react-intl';

import WorkOrdersListModal from '@/components/_common/WorkOrdersListModal';
import { useDisclosure } from '@/hooks';
import { WorkOrderComplementStatusNumber } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { DateTimeFormat } from '@/utils/moment';
import moment from 'moment';
import {
  StatisticDashboardModule,
  StatisticDashboardTypeColor,
} from '@/components/_common/StatisticDashboard';
import DashboardStatisticCard from '../../DashboardStatisticCard';
import formatterPrice from '@/utils/number/formatterPrice';

interface Props {
  value?: number;
}

function MonthlyTotalWorkOrderAverageRealTicket({ value }: Props) {
  const intl = useIntl();
  const [viewWorkOrdersOpen, viewWorkOrdersActions] = useDisclosure();

  return (
    <>
      <DashboardStatisticCard
        tooltipTitle="Calculamos essa métrica dividindo o valor total dos orçamentos fechados do mês atual pela quantidade desses orçamentos."
        statisticTitle={intl.formatMessage({
          id: 'dashboard.monthlyTotalWorkOrderAverageRealTicket',
        })}
        color={StatisticDashboardTypeColor.info}
        value={formatterPrice(value || 0)}
        module={StatisticDashboardModule.workOrder}
        onClick={viewWorkOrdersActions.open}
      />

      <WorkOrdersListModal
        open={viewWorkOrdersOpen}
        onCancel={viewWorkOrdersActions.close}
        queryFilter={{
          status: [WorkOrderComplementStatusNumber.Closed],
          authorizationInitialDate: moment()
            .startOf('month')
            .format(DateTimeFormat),
          authorizationFinalDate: moment()
            .endOf('month')
            .format(DateTimeFormat),
          closingInitialDate: moment().startOf('month').format(DateTimeFormat),
          closingFinalDate: moment().endOf('month').format(DateTimeFormat),
          onlyFirstComplements: true,
        }}
      />
    </>
  );
}

export default MonthlyTotalWorkOrderAverageRealTicket;
